import React, { useEffect, useState } from 'react'
import DropdownList from 'react-widgets/DropdownList'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import 'react-widgets/styles.css'
import { DropdownListUi } from './ui/dropdown-list-ui'
import { generateDate, getDefaultTime, timeOptions } from './utils'

export interface TimePickerControlProps {
  dateTime: Date
  updateDate: (date: Date) => void
  showDate?: boolean
  minuteInterval?: 15 | 30
}

export const TimePickerControl = ({
  dateTime,
  updateDate,
  showDate = true,
  minuteInterval = 30,
}: TimePickerControlProps) => {
  const { i18n } = useTypedTranslation()
  const fallbackLng = i18n.options.fallbackLng
    ? (i18n.options.fallbackLng as string[])[0]
    : 'en'
  const language = i18n.language || fallbackLng
  const [time, setTime] = useState<string>(getDefaultTime(dateTime, language))

  useEffect(() => {
    setTime(getDefaultTime(dateTime, language))
  }, [dateTime, language])

  return (
    <DropdownListUi showDate={showDate}>
      <DropdownList
        className="h-full"
        containerClassName="h-full"
        data={timeOptions(language, minuteInterval)}
        onChange={nextTime => {
          setTime(nextTime)
          updateDate(generateDate({ date: new Date(dateTime), time: nextTime }))
        }}
        value={time}
      />
    </DropdownListUi>
  )
}
